import { render, staticRenderFns } from "./TagNode.vue?vue&type=template&id=6163b579&scoped=true"
import script from "./TagNode.vue?vue&type=script&lang=js"
export * from "./TagNode.vue?vue&type=script&lang=js"
import style0 from "./TagNode.vue?vue&type=style&index=0&id=6163b579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6163b579",
  null
  
)

export default component.exports